import { render, staticRenderFns } from "./BcBubble.vue?vue&type=template&id=7b14ecce&scoped=true"
import script from "./BcBubble.vue?vue&type=script&lang=js"
export * from "./BcBubble.vue?vue&type=script&lang=js"
import style0 from "./BcBubble.vue?vue&type=style&index=0&id=7b14ecce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b14ecce",
  null
  
)

export default component.exports